import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { ReactComponent as GolferIcon } from '../../../assets/images/common/icons/golfer-half-icon.svg'

import classes from './TablePlaceholder.module.scss'

const TablePlaceholder = ({ message }) => {
  const { t } = useTranslation()

  return (
    <div className={classes.placeholderContainer}>
      <div className='d-flex align-items-center flex-column'>
        <GolferIcon className={classes.icon} />
        <h4 className='my-3'>{message || t('common.noData')}</h4>
      </div>
    </div>
  )
}

TablePlaceholder.propTypes = {
  message: PropTypes.string,
}

export default TablePlaceholder
